import {useResolvedPath} from 'react-router'
import {useDeepCompareEffect} from 'react-use'
import {Crumb, useCrumbs} from '../providers/crumbs'

interface LinkCrumbtrailProps {
  crumbs: Crumb[]
}

export const useSetCrumbs = (crumbs: Crumb[]) => {
  const here = useResolvedPath('./')
  const {setCrumbs} = useCrumbs()

  useDeepCompareEffect(() => {
    // using deep compare so we don't need to worry about a new array reference
    setCrumbs(
      crumbs.map(crumb =>
        typeof crumb === 'string'
          ? crumb
          : crumb[0][0] === '.' // detect relative path
          ? [`${here.pathname}/${crumb[0]}`, crumb[1]] // make absolute as RR will otherwise have these relative to the render of header/Crumbs component
          : crumb
      )
    )
    return () => setCrumbs(undefined)
  }, [crumbs, here.pathname])
}

/**
 * @deprecated Use UseSetCrumbs instead
 *
 * This component exists from before we changed the render location of breadcrumbs
 */
export const LinkCrumbtrail = ({crumbs}: LinkCrumbtrailProps) => {
  useSetCrumbs(crumbs)

  return null
}
